import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import {
	type PortfolioCategoryId,
	PortfolioCategoryIds,
} from "web_myplann/Portfolio/Types/portfolioCategory";

export const portfolioCategoryOf = (
	domain: ClientPortfolioDomainEnum | null | undefined,
): PortfolioCategoryId => {
	if (domain === null || domain === undefined) {
		return PortfolioCategoryIds.uncategorized;
	}
	if (domain === ClientPortfolioDomainEnum.PaidAdvisory) {
		return ClientPortfolioDomainEnum.Services;
	}
	return domain;
};

export const portfolioGroupLabel = (id: PortfolioCategoryId) => {
	if (id === PortfolioCategoryIds.property) {
		return Resources.Portfolio.List.Redesign.Categories.assets;
	}
	if (id === PortfolioCategoryIds.uncategorized) {
		return Resources.Portfolio.List.PortfolioDomainType.Uncategorized;
	}
	return Resources.Portfolio.List.PortfolioDomainType[
		id as ClientPortfolioDomainEnum
	];
};
